import { jsx as _jsx } from "react/jsx-runtime";
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { ResourceManagementPage } from 'routes/vendor/lazy-imports';
// import { retryImportInsideRoutesDefinition } from 'utils/lazyWithRetry';
export const resourceManagementRoutes = {
    path: `${ROUTE_PATHS.RESOURCE_MANAGEMENT}/*`,
    element: /*#__PURE__*/ _jsx(SecureRoute, {
        rule: "RESOURCE_MANAGEMENT:READ",
        children: /*#__PURE__*/ _jsx(ResourceManagementPage, {})
    })
};
